









































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import Evaluation from '@/evaluations/entities/evaluation'

@Component
export default class EvaluationsTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  private loading!: boolean

  @Prop({ default: () => [] })
  private items!: Evaluation[]

  private get headers() {
    return [
      {
        text: '',
        value: 'status',
        sortable: false,
        width: 70,
      },
      {
        text: this.$tc('evaluations.entities.evaluation.companyName'),
        value: 'companyName',
        sortable: true,
      },
      {
        text: this.$tc('evaluations.entities.evaluation.referenceNumber'),
        value: 'referenceNumber',
        sortable: false,
      },
      {
        text: this.$tc('evaluations.entities.evaluation.title'),
        value: 'title',
        sortable: false,
      },
      {
        text: this.$tc('evaluations.entities.evaluation.moderator'),
        value: 'moderatorLastName',
        sortable: false,
      },
      {
        text: this.$tc('evaluations.entities.evaluation.finishedAt'),
        value: 'finishedAt',
        sortable: true,
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        cellClass: 'table-actions',
        align: 'end',
      },
    ]
  }

  private details(item: Evaluation) {
    this.$emit('details', item)
  }

  private edit(item: Evaluation) {
    this.$emit('edit', item)
  }

  private clone(item: Evaluation) {
    this.$emit('clone', item)
  }

  private remove(item: Evaluation) {
    if (
      confirm(
        this.$tc('evaluations.components.evaluations-table.confirm_remove')
      )
    ) {
      this.$emit('remove', item)
    }
  }
}
